import { render, staticRenderFns } from "./PersonCardNew.vue?vue&type=template&id=60a2f662&scoped=true&"
import script from "./PersonCardNew.vue?vue&type=script&lang=js&"
export * from "./PersonCardNew.vue?vue&type=script&lang=js&"
import style0 from "./PersonCardNew.vue?vue&type=style&index=0&id=60a2f662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2f662",
  null
  
)

export default component.exports